import * as React from "react";
import {connect} from "react-redux";
import {Routine} from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";
import {Col, Grid, Row} from "react-bootstrap";

import {initialize} from "./Store/routines";
import Customer from "./Customer";
import Form from "./Form";
import styled from "styled-components";
import Spinner from "../Spinner";
import { Title} from "../styles";
import SubUnitsSVG from "../../Elements/Icon/Icons/menu/SubUnits";
import { useIntl } from "react-intl";
import { AppState } from "@Safemate/Store/types";
import { ICustomer } from "@Safemate/Model/Customer";
import InformationIcon from "../../Elements/Icon/Icons/InformationIcon";
import Tooltip from "@Elements/Tooltip";

interface SubUnitsProps {
  init: Routine<ActionFunctionAny<Action<any>>>;
  customer: ICustomer;
  initialized: boolean;
}

const CenteredRow = styled(Row)`
  display: flex;
  justify-content: center;
`

const StyledCol = styled(Col)`
  display: flex;
  margin-left: 15px;
  svg{
    width: 32px;
    height: 32px;
    float: left;
    margin-top: 9px;
  }
`

export const Frame = styled.div`
  border-radius: 4px;
  padding: 25px;
  padding-right: 40px;
  padding-left: 30px;
  ${props =>
  `
    background: ${props.theme.colors.backgroundPrimary};
    border: ${props.theme.colors.border};
  `
}
`;

const Wrap = styled.div`
  position: relative;
`

const mapStateToProps = ({ appData: { superfirm }, subUnits: {initialization: {initialized}}}: AppState) => {
  return{
    initialized,
    customer: superfirm,
  }
};

const mapDispatchToProps  = {
  init: initialize
};

// Outer component responsible for loading initial data.
export default connect(mapStateToProps, mapDispatchToProps)(({init, initialized, customer }: SubUnitsProps) => {

  const {formatMessage} = useIntl();
  // On mount
  React.useEffect(() => {
    init();
  }, []);

  if(!initialized)
    return (
      <Wrap>
        <Spinner show message={formatMessage({id: "initData", defaultMessage: "Initialisering av data"})}/>
      </Wrap>
    )

  return(
    <Wrap>
      <Grid fluid>
        <Row>
          <StyledCol>
            <h1><SubUnitsSVG/></h1>
            <Title>
              {formatMessage({id: "subUnitsIn", defaultMessage: "Underavdelinger i"})}
              &nbsp;
              {customer.name}
            </Title>
            <Tooltip
                popoverId="subUnits-popover"
                labelId="subunitsHeaderTooltip"
                defaultMessage="Denne siden viser organisasjonsstrukturen for kommunen, med rotnivået øverst og de underliggende nivåene som en trestruktur."
              >
              <InformationIcon size="medium" />
            </Tooltip>
          </StyledCol>
        </Row>
        <Row>
          <Col md={6}>
            <Customer/>
          </Col>
          <Col md={6}>
            <Frame>
              <Row>
                <Form/>
              </Row>
            </Frame>
          </Col>
        </Row>
      </Grid>
    </Wrap>
  )
});